module.exports = __webpack_public_path__ + "static/media/supermercado.a1b58d5a.jpg";